<div class="artifacts-page">
  <div class="artifacts-header">
    <h1 class="artifacts-title">Artifacts</h1>
  </div>

  <div class="artifacts-view-tabs">
    <span class="view-tab active">Created by Me</span>
  </div>

  <div class="artifacts-toolbar">
    <div class="search-control">
      <svg-icon src="assets/icons/search.svg" svgClass="search-icon" />
      <gains-input icon="assets/icons/search.svg" placeholder="Search artifacts..." [(ngModel)]="searchTerm" />
    </div>
  </div>

  <!-- Hidden rather than left empty: .artifacts-grid is flex: 1, so an empty grid would keep the column's
       whitespace and squeeze the failed/empty state below it instead of centring it in the panel. -->
  <div class="artifacts-grid" *ngIf="filteredArtifacts.length > 0">
    <div
      class="artifact-card"
      *ngFor="let artifact of filteredArtifacts; trackBy: trackByArtifactId"
      tabindex="0"
      (click)="viewArtifact(artifact)"
      (keydown.enter)="viewArtifact(artifact)"
    >
      <div class="artifact-card-header">
        <label *ngIf="artifact.isMine" class="select-check" tabindex="-1" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
          <input
            type="checkbox"
            [checked]="isArtifactSelected(artifact.id)"
            [attr.aria-label]="'Select artifact ' + artifact.name"
            (change)="toggleArtifactSelection(artifact.id, $event)"
            (keydown.enter)="onCheckboxKey($event, artifact.id)"
            (keydown.space)="onCheckboxKey($event, artifact.id)"
          />
          <span class="checkmark"></span>
        </label>
        <span class="artifact-name">{{ artifact.name }}</span>
        <gains-ellipsis-menu
          class="card-menu"
          [menuItems]="artifact.isMine ? artifactsMenuItems : sharedArtifactMenuItems"
          [dropdownWidth]="'200px'"
          (click)="$event.stopPropagation()"
          (keydown)="$event.stopPropagation()"
          (changeEvent)="onArtifactMenuAction($event, artifact)"
        ></gains-ellipsis-menu>
      </div>

      <div class="artifact-meta">
        <span class="artifact-chip type-chip">
          <svg-icon src="assets/icons/code.svg" class="meta-icon"></svg-icon>
          {{ artifact.type }}
        </span>
        <span class="meta-dot">&bull;</span>
        <span class="artifact-chip date-chip">
          <svg-icon src="assets/icons/calendar.svg" class="meta-icon"></svg-icon>
          {{ artifact.createdAt }}
        </span>
      </div>
    </div>
  </div>

  <!-- Artifact Failed / Empty State -->
  <deo-panel-state *ngIf="loadError && !isLoading" mode="error" title="Couldn't load artifacts" [message]="loadError" (retry$)="retryLoad()"></deo-panel-state>
  <deo-panel-state *ngIf="!loadError && filteredArtifacts.length === 0 && !isLoading" mode="empty" icon="assets/icons/chat.svg" title="No Artifact Found"></deo-panel-state>

  <gains-bulk-actions-drawer [selectedItems]="selectedArtifactIds">
    <div class="selection-info">
      <span class="selection-count">{{ selectedArtifactIds.length }} artifact{{ selectedArtifactIds.length !== 1 ? 's' : '' }} selected</span>
    </div>
    <button nz-button nzType="default" nzDanger (click)="deleteSelectedArtifacts($event)">
      <svg-icon src="assets/icons/trash-1.svg" title="Delete" />
      Delete
    </button>
  </gains-bulk-actions-drawer>
</div>
